import TimeAgoInterval from './TimeAgoInterval';

export default TimeAgoInterval;